export default __webpack_public_path__ + "static/media/stickla-logo.8efad72f.svg";